import { FormControlLabel, MenuItem, Select } from "@mui/material";
import CustomPagination from "components/CustomPagination";
import SearchComponent from "components/SearchComponent";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { removeItemArray } from "lib/arrayObject";
import { serverGet, serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import DeliveryTicketTable from "./DeliveryTicketTable";

const options = [
  { label: "All", tab: "all" },
  { label: "Label Created", tab: "1" },
  { label: "Delivered", tab: "2" },
  { label: "Cancelled", tab: "0" },
];

export default function DeliveryTicketComponent() {
  const [status, setStatus] = useState("all");
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);
  const [searchWord, setSearchWord] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [page, setPage] = useState(1);
  const [isNext, setIsNext] = useState(true);
  const [total, setTotal] = useState(1);

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };
  const handleView = (row) => {
    history.push(`/delivery-ticket/${row.id}`);
  };

  const searchData = useMemo(() => {
    let filteredData = data;
    if (searchWord) {
      filteredData = filteredData.filter((row) => {
        const newStr = {
          ...row,
          address: row?.address?.label ?? "",
          customer: row?.receiver?.name ?? "",
          ...(row?.receiver.address ?? {}),
        };
        let searchWords = searchWord.split(" "),
          s = 0,
          strObject = Object.values(newStr).join("");
        searchWords.forEach((t) => {
          if (strObject.toLowerCase().search(t.toLowerCase()) > 0) s++;
        });
        if (s > 0) return true;
        else return false;
      });
    }
    return filteredData;
  }, [data, searchWord]);

  const loadData = () => {
    openLoading(true);
    serverPost({
      url: "deliveryTicket",
      data: {
        dateRange: dateRange,
        status:
          status === "all"
            ? ""
            : options.find((item) => item.tab === status).label,
        page: page,
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          errorAction(res, err);
          return;
        }
        if (!Boolean(res.size)) {
          setIsNext(false);
          setPage((prev) => (prev === 1 ? prev : prev - 1));
          setTotal((prev) => (prev === 1 ? prev : prev - 1));
        }
        setIsNext(true);
        setData(res?.items ?? []);
      },
    });
  };

  const handleDelete = (row, rowIndex) => {
    openLoading(true);
    serverGet({
      url: `deliveryZone/delete/${row.id}`,
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          errorAction(res, err);
          return;
        }
        setData((s = []) => removeItemArray(s, rowIndex));
        enqueueSnackbar("Delivery zone deleted succesfully.", {
          variant: "success",
        });
      },
    });
  };

  const handleSearchWord = (e) => {
    setSearchWord(e.target.value.trim().replace(/[^A-Za-z0-9@. ]/g, ""));
  };

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, [dateRange, status, page]);

  useEffect(() => {
    setTotal(1);
    setIsNext(true);
  }, [dateRange, status]);

  return (
    <div>
      <div className="flex justify-between mb-4">
        <div className="flex">
          <SearchComponent
            onKeyDown={(e) => handleSearchWord(e)}
            onBlur={handleSearchWord}
            searchWord={searchWord}
            placeholder="Search Staff Users"
          />
          <FormControlLabel
            value="start"
            label={
              <CustomText
                className="whitespace-nowrap"
                variant="body2"
                color="secondary"
                bold={true}
              >
                Status :&nbsp;
              </CustomText>
            }
            labelPlacement="start"
            control={
              <Select
                size="small"
                sx={{ background: "#fff", width: 160 }}
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
              >
                {options?.map((item) => (
                  <MenuItem value={item?.tab} key={item?.tab}>
                    {item?.label ?? ""}
                  </MenuItem>
                ))}
              </Select>
            }
          />
        </div>
        <FormControlLabel
          className="z-10"
          sx={{ marginRight: 0 }}
          label={
            <CustomText
              className="whitespace-nowrap"
              variant="body2"
              color="secondary"
              bold={true}
            >
              Date :&nbsp;
            </CustomText>
          }
          labelPlacement="start"
          control={
            <DatePicker
              className="px-2 py-1 border rounded border-white-gray"
              selectsRange={true}
              startDate={startDate}
              dateFormat={"dd MMM"}
              endDate={endDate}
              onChange={(update) => {
                setPage(1);
                setDateRange(update);
              }}
              isClearable={true}
            />
          }
        />
      </div>
      <DeliveryTicketTable
        data={searchData ?? []}
        onView={handleView}
        onDelete={handleDelete}
      />
      <CustomPagination
        total={total}
        page={page}
        isNext={isNext}
        onClickPrev={() => setPage((prev) => prev - 1)}
        onClickNext={() => {
          setPage((prev) => prev + 1);
          setTotal((prev) => (page < total ? prev : prev + 1));
        }}
        onClickPage={(num) => setPage(num)}
      />
      {/* <div className="bg-white flex justify-center items-center py-2 border-t border-white-gray">
        <Pagination
          variant="outlined"
          page={page}
          onChange={(e, v) => setPage(v)}
        />
      </div> */}
    </div>
  );
}
